export default "__VITE_ASSET__D3E$zEkH__"